import React from 'react';
import styled from 'styled-components';

import Timer from 'app/ui/components/molecules/timer';
import Typography from 'app/ui/components/atoms/typography';
import useTimer from 'src/app/hooks/use-timer';

export interface SlideTimerProps {
  endSeconds: number;
  timerId: string;
  isPresenterView?: boolean;
}

const TimerContainer = styled.div<{ $isPresenterView?: boolean }>`
  position: ${({ $isPresenterView }) => ($isPresenterView ? 'block' : 'absolute')};
  top: 2rem;
  right: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${({ theme }) => theme.colors.timerGreen};
  border-radius: ${({ theme }) => theme.spacing(3)};
  height: 6.5rem;
`;

const TopTimer = styled(Timer)`
  display: inline-flex;
  border: ${({ theme }) => `4px solid ${theme.colors.timerGreen}`};
  background: ${({ theme }) => theme.colors.black};
  border-radius: 0;
  border-top-left-radius: ${({ theme }) => theme.spacing(3)};
  border-bottom-left-radius: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.colors.white};
  height: 100%;
  width: 16.5rem;
  font-size: 4.75rem;
`;

const TextPeriodWrapper = styled(Typography)`
  width: 14rem;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
  font-weight: bold;
`;

const SlideTimer: React.FC<SlideTimerProps> = ({ endSeconds, timerId, isPresenterView = false }) => {
  const { elapsedTime, reset } = useTimer({
    timerId,
    finalDuration: endSeconds || 0,
  });

  return (
    <TimerContainer data-testid="top-timer">
      <TopTimer isPresenterView={isPresenterView} elapsedTime={elapsedTime} reset={reset} />
      {/* TODO - workout/rest */}
      <TextPeriodWrapper variant="h2">Work</TextPeriodWrapper>
    </TimerContainer>
  );
};

export default SlideTimer;
